import { render, staticRenderFns } from "./approval-collection.vue?vue&type=template&id=abfe443a&scoped=true"
import script from "./approval-collection.vue?vue&type=script&lang=js"
export * from "./approval-collection.vue?vue&type=script&lang=js"
import style0 from "./approval-collection.vue?vue&type=style&index=0&id=abfe443a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfe443a",
  null
  
)

export default component.exports